export default "__VITE_ASSET__bd85eeb7__"